import { XdrSearchTabPanelComponent } from './component/XdrSearchTabPanelComponent';
import { WEB_COMPONENT_XDR_SEARCH_TAB_PANEL } from '../../webcomponents.constants';

export { XdrSearchTabPanelComponent };

window.customElements.define(WEB_COMPONENT_XDR_SEARCH_TAB_PANEL, XdrSearchTabPanelComponent);
